export const skipLineText = (text) => {
  let variable1, variable2;

  if (text.length <= 40) {
    variable1 = text;
    variable2 = "";
  } else {
    const lastSpaceIndex = text.lastIndexOf(" ", 40);
    variable1 = text.substring(0, lastSpaceIndex);
    variable2 = text.substring(lastSpaceIndex + 1);
  }

  return [variable1, variable2];
};
